import React, { useState, useEffect } from "react";
import { Menu, X } from "lucide-react";
import { AdminNavigation, EmpNavigation } from "../../../Constants";
import { getValuesFromLocalstorage } from "../../Helpers";
import LOCAL_KEYS, {
  parseLocalStorageJSON,
} from "../../../helpers/Localstorage";
import MenuItem from "./MenuItems";
import Swal from "sweetalert2";
import { useLocation, useNavigate } from "react-router-dom";
import Uni_Logo from "../../../Assets/newlogo.jpeg";
import { useDispatch, useSelector } from "react-redux";
import { toggleMenubar } from "../../../Redux/AppconifgStage/AppconfigActionCreator";
import { Close } from "@mui/icons-material";
import uniLogo from "../../../Assets/Uni_Logo.png";
const Sidebar = () => {
  const [isOpen, setIsOpen] = useState(false);
  const [activeItem, setActiveItem] = useState("");
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const location = useLocation();
  const appConfigState = useSelector((state) => state.AppConfigReducer);
  const { expandMenuBar } = appConfigState;
  const appConfigHoverState = useSelector(
    (state) => state.AppConfigHoverReducer
  );
  const { hover } = appConfigHoverState;

  const userDetails = parseLocalStorageJSON(LOCAL_KEYS.USER_DETAILS);
  const userType =
    getValuesFromLocalstorage("userDetails")?.acctType || "EMPLOYEE";

  const Navigation = AdminNavigation;

  useEffect(() => {
    const currentItem =
      location.state?.activeItem ||
      Navigation.find((item) => item.href === location.pathname)?.name;
    setActiveItem(currentItem);
  }, [location]);

  const handleLogout = () => {
    Swal.fire({
      title: "Are you sure you want to Logout?",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Yes, Logout!",
      backdrop: `rgba(0, 0, 0, 0.5)`,
    }).then((result) => {
      if (result.isConfirmed) {
        localStorage.clear();
        navigate("/login");
      }
    });
  };

  const handleMenuAction = () => {
    if (window.innerWidth < 768) {
      dispatch(toggleMenubar(!expandMenuBar));
    }
  };

  return (
    <>
      {/* Sidebar Container */}
      <div
        className={`fixed top-0 left-0  md:sticky md:left-2 z-30 md:z-0  my-2 rounded-2xl bg-white p-3 
      shadow-xl h-[98vh] transition-all duration-300  overflow-y-scroll no-scrollbar
      ${
        expandMenuBar
            ? "w-64 translate-x-0"
            : "w-20 -translate-x-[100%] sm:translate-x-0"
          } 
      `}
      >
        {/* Close Button  */}
        {expandMenuBar && (
          <button
            onClick={() => dispatch(toggleMenubar(false))}
            className="absolute top-3 left-3 text-gray-700 hover:text-black md:hidden"
          >
            <Close fontSize="small" />
          </button>
        )}

        {/* Logo & Title */}
        {/* <div className="flex justify-start items-center gap-3">
          <div className="flex-shrink-0 ml-1">
            <img
              className="w-[88px] h-[54px] sm:w-14 sm:h-16 p-1 rounded-lg object-contain" 
              src={Uni_Logo}
              alt="Company Logo"
            />
          </div>
          {expandMenuBar && (
            <p className="text-primary text-xl font-extrabold tracking-wider hover:text-cyan-700 transition-all duration-300 font-mono first-letter:text-2xl first-letter:text-cyan-700">Unisoft</p>
          )}
        </div> */}

        <div className="flex items-center justify-center">
          <div className={`flex items-center ${expandMenuBar ? 'justify-start w-full' : 'justify-center'}`}>
            <img
              className={`pl-2 w-auto transition-all duration-300 ${expandMenuBar ? 'h-[4.5rem]' : 'h-[3.5rem]'}`}
              src={expandMenuBar ? Uni_Logo : uniLogo}
              alt="Unisoft Logo"
            />
          </div>
        </div>
        {/* <img
      className={`object-contain transition-all duration-300 ${
     expandMenuBar ? 'w-48 h-16' : 'w-36 h-14'
      }`}
      src={Uni_Logo}
      alt="Unisoft Logo"
    /> */}
        {/* {expandMenuBar && (
      <p className="text-primary text-xl font-extrabold tracking-wider hover:text-cyan-700 transition-all duration-300 font-mono first-letter:text-2xl first-letter:text-cyan-700 -ml-2">
        Unisoft
      </p>
    )} */}

        <hr className="border-gray-200" />

        {/* Navigation Menu */}
        {/* <MenuList
        items={Navigation}
        onLogout={handleLogout}
        navigate={navigate}
        onMenuAction={handleMenuAction}
      /> */}

        <MenuItem items={Navigation} />
      </div>
    </>
  );
};

export default Sidebar;
